import { useQuery } from "react-query";
import { Vehicle } from "../models";
import { IVehicle } from "../types";
import { useCache } from "../context/CacheContext";
import { useWorkspace } from "../context/WorkspaceContext";
import { useUserSession } from "../context/UserContext";
import { listVehicles } from "../data/api/vehicles";
import { queryKeys } from "../data/queryKeys";

/**
 * Workspace vehicles, read through the REST API (previously a direct Firestore
 * query). Query key, cache-key invalidation and `Vehicle[]` instance return
 * shape are preserved.
 */
export const useVehicles = (workspaceId?: string) => {
  const { cacheKey } = useCache();
  const { activeWorkspace } = useWorkspace();
  const { userSession, isAuthenticated } = useUserSession();
  const resolvedWorkspaceId = workspaceId ?? activeWorkspace?.workspaceId ?? "";
  const token = userSession?.token?.accessToken;

  return useQuery<Vehicle[], Error>(
    queryKeys.vehicles(cacheKey, resolvedWorkspaceId),
    async () => {
      const vehicles = await listVehicles(token as string, resolvedWorkspaceId);
      return vehicles.map((vehicle: IVehicle) => new Vehicle(vehicle));
    },
    {
      enabled: !!token && !!resolvedWorkspaceId && isAuthenticated(),
    },
  );
};
